module.exports = __webpack_public_path__ + "static/media/bm.60c6fe15.svg";